import Image from 'next/image';

export interface CoinIconProps {
  size?: number;
  tokenImage: string;
}

export const CoinIcon = ({ tokenImage, size = 48 }: CoinIconProps) => {
  return <Image width={size} height={size} src={tokenImage} alt={tokenImage} />;
};
